export default {  
    initCart({ commit , state } , cart ){
        commit('setCart', cart);
        commit('setInitCart' , true);
    }
}